import {FuncaoMenuV2} from './menu-v2.catalogo';
import {DESCRICOES_DAS_FUNCOES, EstadoDoMenuOnboarding, faseDaFuncao, funcaoVisivelNoMenu, QUANDO_CHEGA}
  from '../../../../server/lib/onboarding/FasesDoMenuOnboarding';

/**
 * Menu que cresce com a loja (docs/requisito-onboarding-painel-v1.md, seção 5). Filtro a mais sobre o catálogo,
 * com as fases do arquivo puro do servidor: o que ainda não é da fase vira `somenteBusca` — some da navegação,
 * mas a busca continua achando tudo, e o Descobrir mostra o que está guardado. Nunca libera o que o catálogo não
 * trouxe (módulo, recurso e permissão continuam mandando).
 */
export type OnboardingDoMenu = EstadoDoMenuOnboarding & {experiente?: boolean; novas?: string[]};

export interface GrupoDeGuardadas { quando: string; itens: Array<{funcao: FuncaoMenuV2; descricao: string}>; }

export const FUNCAO_COMECAR: FuncaoMenuV2 = {
  peso: 3, id: 'comecar', rota: '/admin/comecar', nome: 'Primeiros passos', descricao: 'O que falta para o primeiro pedido',
  grupo: 'inicio', secao: 'Primeiros passos', icone: 'fe-flag', termos: 'começar onboarding primeiros passos configurar loja',
  somenteBusca: false
};

/** Ações, conta, itens internos da equipe e o que já é só da busca nunca entram no filtro. */
function foraDoFiltro(f: FuncaoMenuV2): boolean {
  return !!f.acao || f.grupo === 'conta' || !!f.somenteBusca || !!f.interna;
}

export function apliqueFaseDoOnboarding(funcoes: FuncaoMenuV2[], onboarding: OnboardingDoMenu | null | undefined): FuncaoMenuV2[] {
  if (!onboarding) return funcoes;
  const lista = onboarding.ativo && !funcoes.some(f => f.id === FUNCAO_COMECAR.id) ? [FUNCAO_COMECAR, ...funcoes] : funcoes;
  if (onboarding.menuCompleto) return lista;
  return lista.map(f => foraDoFiltro(f) || funcaoVisivelNoMenu(f.id, onboarding) ? f : {...f, somenteBusca: true});
}

/** O que está guardado, agrupado pelo momento em que costuma fazer sentido (a próxima leva primeiro). */
export function funcoesGuardadas(originais: FuncaoMenuV2[], onboarding: OnboardingDoMenu | null | undefined): GrupoDeGuardadas[] {
  if (!onboarding || onboarding.menuCompleto) return [];
  const guardadas = (originais || []).filter(f => !foraDoFiltro(f) && !funcaoVisivelNoMenu(f.id, onboarding));
  const porFase = new Map<number, GrupoDeGuardadas>();
  for (const f of guardadas) {
    const fase = faseDaFuncao(f.id) || 9;
    if (!porFase.has(fase)) porFase.set(fase, {quando: (QUANDO_CHEGA as any)[fase] || 'Outras funções', itens: []});
    porFase.get(fase).itens.push({funcao: f, descricao: DESCRICOES_DAS_FUNCOES[f.id] || f.descricao});
  }
  return Array.from(porFase.entries()).sort((a, b) => a[0] - b[0]).map(([, grupo]) => grupo);
}
